export const payment = {
  'seo.title': 'Запись на Консультацию — Цены и Программы | София и Елена',
  'seo.description': 'Выберите программу нутрициологического сопровождения: VIP-сопровождение от €500, протокол FMD €35, детская нутрициология €400, групповые интенсивы €250.',
  'seo.keywords': 'цены нутрициолог, стоимость консультации, запись к нутрициологу',

  'hero.title': 'Выберите свой путь к здоровью',
  'hero.description': 'Каждая программа — это индивидуальный подход и забота двух экспертов',

  'popularChoice': 'Популярный выбор',

  'service1.title': 'VIP Сопровождение',
  'service1.duration': '1 месяц',
  'service1.price': '€500',
  'service1.feature1': 'Ежедневная поддержка в чате',
  'service1.feature2': 'Разбор анализов',
  'service1.feature3': 'Индивидуальный план питания',
  'service1.feature4': 'Работа со стрессом',
  'service1.feature5': 'Консультации двух экспертов',

  'service2.title': 'VIP Сопровождение',
  'service2.duration': '2 месяца',
  'service2.price': '€900',
  'service2.feature1': 'Все из пакета 1 месяц',
  'service2.feature2': 'Глубокая трансформация',
  'service2.feature3': 'Работа с семейным питанием',
  'service2.feature4': 'Корректировка протокола',
  'service2.feature5': 'Максимальный результат',

  'service3.title': 'Протокол FMD',
  'service3.duration': '10 дней',
  'service3.price': '€35',
  'service3.feature1': 'Клеточное омоложение',
  'service3.feature2': 'Детальный план на 10 дней',
  'service3.feature3': 'Ежедневная поддержка',
  'service3.feature4': 'Биохакинг организма',
  'service3.feature5': 'Научный подход',

  'service4.title': 'Детская нутрициология',
  'service4.duration': 'Индивидуально',
  'service4.price': '€400',
  'service4.feature1': 'Работа с аллергиями',
  'service4.feature2': 'Формирование пищевых привычек',
  'service4.feature3': 'Укрепление иммунитета',
  'service4.feature4': 'План для всей семьи',
  'service4.feature5': 'Поддержка родителей',

  'service5.title': 'Групповой интенсив',
  'service5.duration': '3-4 человека',
  'service5.price': '€190',
  'service5.feature1': 'Энергия комьюнити',
  'service5.feature2': 'Мягкие протоколы',
  'service5.feature3': 'Групповая поддержка',
  'service5.feature4': 'Быстрый старт',
  'service5.feature5': 'Доступная цена',

  'service6.title': 'Пакет самостоятельный',
  'service6.duration': 'Разовая услуга',
  'service6.price': '€150',
  'service6.feature1': 'Детальный разбор показателей анализов',
  'service6.feature2': 'Рекомендации по дефицитам',
  'service6.feature3': 'План действий и питания',
  'service6.feature4': 'Консультация эксперта 1 раз в 10 дней',

  'selected': 'Выбрано',
  'select': 'Выбрать',
  'selectServiceAria': 'Выбрать {{service}}',

  'form.title': 'Запись на консультацию',
  'form.description': 'Заполните форму, и мы свяжемся с вами в течение 24 часов',
  'form.name.label': 'Ваше имя',
  'form.name.placeholder': 'Введите ваше имя',
  'form.email.label': 'Email',
  'form.email.placeholder': 'your@email.com',
  'form.phone.label': 'Телефон',
  'form.phone.placeholder': '+7 (___) ___-__-__',
  'form.service.label': 'Выберите услугу',
  'form.service.placeholder': 'Выберите услугу',
  'form.message.label': 'Сообщение',
  'form.message.placeholder': 'Расскажите о ваших целях и пожеланиях (до 500 символов)',
  'form.message.characters': 'символов',
  'form.submit': 'Отправить заявку',
  'form.submitting': 'Отправка...',
  'form.successMessage': 'Спасибо! Ваша заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.',
  'form.errorMessage': 'Произошла ошибка. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.',

  'cta.title': 'Не уверены, какая программа вам подходит?',
  'cta.description': 'Запишитесь на бесплатную диагностическую консультацию, и мы поможем выбрать оптимальный путь',
  'cta.button': 'Записаться на бесплатную консультацию',
  'cta.buttonAria': 'Записаться на бесплатную консультацию',
};